import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import Card from '../../../../../molecules/Card'
import InlineCardHeader from '../../../../../molecules/Card/InlineCardHeader'
import FieldDisplay from '../../../../../molecules/FieldDisplay'
import { usePolicy } from '../../../../../../hooks/usePolicy'
import DatasourceDescription from '../shared/DatasourceDescription'
import DatasourceActionsMenu from '../shared/DatasourceActionsMenu'

function AiFeatureAttributes ({ datasource }) {
  const isInternalUser = usePolicy('admin_denali_internal')

  const fields = useMemo(() => {
    const target = datasource?.data?.target || {}

    const baseFields = [
      { label: 'ID', value: datasource.catalogDatasourceId },
      { label: 'Name', value: datasource.displayName },
      { label: 'Code', value: datasource.code },
      { label: 'Sub-Type', value: datasource.subType },
      { label: 'Target Service', value: target.service || '—' },
      { label: 'Target Command', value: target.command || '—' },
      { label: 'Target Query', value: target.query || '—' },
      { label: 'Response Shape', value: target.responseShape || 'result' }
    ]

    const internalFields = isInternalUser
      ? [
        { label: 'is System', value: datasource.isSystem ?? false, format: 'bool' },
        { label: 'is Internal', value: datasource.isInternal ?? false, format: 'bool' }
      ]
      : []

    const otherFields = [
      { label: 'Enabled for firm', value: datasource.isAiEnabled ?? false, format: 'bool' },
      { label: 'is Deprecated', value: datasource.isDeprecated ?? false, format: 'bool' }
    ]

    return [...baseFields, ...internalFields, ...otherFields]
  }, [datasource, isInternalUser])

  return (
    <FieldDisplay fields={fields} />
  )
}

AiFeatureAttributes.propTypes = {
  datasource: PropTypes.object
}

function AiFeatureDetailsTab ({ datasource }) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader
            action={(
              <DatasourceActionsMenu datasource={datasource} />
            )}
          >
            Details
          </InlineCardHeader>
          <AiFeatureAttributes datasource={datasource} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader>Description</InlineCardHeader>
          <DatasourceDescription datasource={datasource} />
        </Card>
      </Grid>
    </Grid>
  )
}

AiFeatureDetailsTab.propTypes = {
  datasource: PropTypes.object
}

export default AiFeatureDetailsTab
